import { LOCALES, LOCALE_LABELS, LOCALE_NAMES } from '../../locale/constants';
import { useLocale } from '../../locale';
import { t } from '../../content';
import globe from '../../assets/images/icons/globe.svg';

/**
 * Clickable EN | DE | FI language switcher.
 * @param {'auth' | 'sidebar' | 'sidebarCollapsed' | 'mobile'} variant
 */
function LanguageSwitcher({ variant = 'auth' }) {
  const { locale, setLocale } = useLocale();

  const cycleLocale = () => {
    const index = LOCALES.indexOf(locale);
    const next = LOCALES[(index + 1) % LOCALES.length];
    setLocale(next);
  };

  if (variant === 'sidebarCollapsed') {
    return (
      <div
        className="language-switcher language-switcher--sidebarCollapsed"
        role="group"
        aria-label={t('common.labels.language')}
      >
        <button
          type="button"
          className="link language-switcher__icon-btn"
          onClick={cycleLocale}
          aria-label={`${t('common.labels.language')}: ${LOCALE_NAMES[locale]}`}
          title={`${t('common.labels.language')}: ${LOCALE_LABELS[locale]}`}
        >
          <img className="navIcon" src={globe} alt="" />
        </button>
      </div>
    );
  }

  return (
    <div
      className={`language-switcher language-switcher--${variant}`}
      role="group"
      aria-label={t('common.labels.language')}
    >
      {variant === 'sidebar' && (
        <span className="language-switcher__label">{t('common.labels.language')}</span>
      )}
      <div className="language-switcher__options">
        {LOCALES.map((code, index) => (
          <span key={code} className="language-switcher__option-wrap">
            {index > 0 && <span className="language-switcher__sep" aria-hidden="true">|</span>}
            <button
              type="button"
              className={
                locale === code
                  ? 'language-switcher__btn is-active'
                  : 'language-switcher__btn'
              }
              onClick={() => setLocale(code)}
              aria-label={LOCALE_NAMES[code] || code}
              aria-current={locale === code ? 'true' : undefined}
            >
              {LOCALE_LABELS[code]}
            </button>
          </span>
        ))}
      </div>
    </div>
  );
}

export default LanguageSwitcher;
